import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Form, { Actions, Address, Assets, PhoneNumber, PhoneNumberValidator, RequiredValidator, TextField, URLValidator } from '../../Components/Form';
import { useBusiness } from '../../Data/Business';
import Tabs, { Tab } from '../../Components/Containers/Tabs/Tabs';

const Details = () => {
    const {business, saveDetails, saveSocials} = useBusiness(true);

    return <>
        <TopBar left="/more" title="Business Details" />

        <Page>
            <Tabs>
                <Tab title="Details">
                    <Form data={business} waitForData onSubmit={saveDetails}>
                        <TextField name="name" label="Business Name" validators={[RequiredValidator]} />
                        <TextField name="tagline" label="Tagline" help="A one line description for your business." />
                        <Assets name="logoId" label="Logo"
                            tags={[{name: 'Logo', value: 'Standard'}]}
                            single showPrevious showShared
                        />
                        <Address name="address" label="Address" validators={[RequiredValidator]} />
                        <PhoneNumber name="phoneNumber" label="Phone number" validators={[RequiredValidator, PhoneNumberValidator]} />
                        <TextField type="url" name="website" label="Website" validators={[URLValidator]} />
                        <TextField name="taxId" label="Tax ID" />
                        <Actions submit={{label: 'Save Details'}} />
                    </Form>
                </Tab>

                <Tab title="Socials">
                    <Form data={business} waitForData onSubmit={saveSocials}>
                        <TextField name="bluesky" label="Bluesky" prefix="@" validators={[]} />
                        <TextField name="facebook" prefix="facebook.com/" label="Facebook" validators={[]} />
                        <TextField name="google" label="Google My Business" prefix="https://" validators={[]} />
                        <TextField name="instagram" prefix="instagram.com/" label="Instagram" validators={[]} />
                        <TextField name="mastodon" label="Mastodon" prefix="https://" validators={[]} />
                        <TextField name="threads" label="Threads" prefix="threads.net/@" validators={[]} />
                        <TextField name="trustPilot" prefix="trustpilot.com/review/" label="TrustPilot" validators={[]} />
                        <TextField name="twitter" prefix="twitter.com/@" label="Twitter" validators={[]} />
                        <TextField name="whatsApp" label="WhatsApp" validators={[]} />
                        <TextField name="youtube" label="Youtube" prefix="youtube.com/@" validators={[]} />

                        <Actions submit={{label: 'Save Socials'}} />
                    </Form>
                </Tab>
            </Tabs>
        </Page>
    </>
}

export default Details;
